<template>
  <div class="tour-card-left-blog-post-card" v-bind:class="rootClassName">
    <img
      :alt="image_alt"
      :src="image_src"
      image_src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDd8fHBvcnRyYWl0fGVufDB8fHx8MTYyNjM3ODk3Mg&amp;ixlib=rb-1.2.1&amp;h=1000"
      class="tour-card-left-image"
    />
    <div class="tour-card-left-container">
      <div class="tour-card-left-container1">
        <span class="tour-card-left-text">{{ label }}</span>
        <span class="tour-card-left-text1">{{ title }}</span>
      </div>
      <h1 class="tour-card-left-text2">{{ title }}</h1>
      <span class="tour-card-left-text3">{{ description }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TourCardLeft',
  props: {
    image_src: {
      type: String,
      default:
        'https://images.unsplash.com/photo-1627914551740-f0d01b81dbb8?ixid=Mnw5MTMyMXwwfDF8YWxsfDE4fHx8fHx8Mnx8MTY0OTUxOTAxOQ&ixlib=rb-1.2.1&w=1500',
    },
    description: {
      type: String,
      default:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non volutpat turpis. Mauris luctus rutrum mi ut rhoncus. Integer in dignissim tortor. Lorem ipsum dolor sit amet, consectetur adipiscing ...',
    },
    rootClassName: String,
    label: {
      type: String,
      default: 'ENTERPRISE',
    },
    image_alt: {
      type: String,
      default: 'image',
    },
    when: {
      type: String,
      default: '3 days ago',
    },
    title: {
      type: String,
      default: 'Lorem ipsum dolor sit amet',
    },
  },
}
</script>

<style scoped>
.tour-card-left-blog-post-card {
  width: 100%;
  display: flex;
  max-width: 1400px;
  box-shadow: 4px 4px 10px 0px rgba(18, 18, 18, 0.1);
  transition: 0.3s;
  align-items: stretch;
  flex-direction: row;
  justify-content: space-between;
}
.tour-card-left-blog-post-card:hover {
  transform: scale(1.02);
}
.tour-card-left-image {
  width: 356px;
  height: 437px;
  object-fit: cover;
  flex-shrink: 0;
  border-radius: 0px;
}
.tour-card-left-container {
  display: flex;
  position: relative;
  align-self: flex-start;
  align-items: flex-start;
  padding-top: 32px;
  padding-left: 32px;
  padding-right: 32px;
  flex-direction: column;
  padding-bottom: 32px;
  justify-content: space-between;
}
.tour-card-left-container1 {
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-bottom: var(--dl-space-space-halfunit);
  flex-direction: row;
  justify-content: space-between;
}
.tour-card-left-text {
  color: var(--dl-color-gray-500);
  font-weight: 600;
  text-transform: uppercase;
}
.tour-card-left-text1 {
  color: var(--dl-color-gray-500);
  font-weight: 300;
}
.tour-card-left-text2 {
  margin-bottom: 32px;
}
.tour-card-left-text3 {
  color: var(--dl-color-gray-500);
  font-size: 1.25rem;
  align-self: flex-start;
  margin-bottom: 32px;
}






@media(max-width: 991px) {
  .tour-card-left-blog-post-card {
    flex-direction: row;
    justify-content: space-between;
  }
}
@media(max-width: 767px) {
  .tour-card-left-blog-post-card {
    flex-direction: column;
  }
  .tour-card-left-image {
    width: 100%;
  }
  .tour-card-left-root-class-name2 {
    margin-bottom: 150px;
  }
  .tour-card-left-root-class-name3 {
    margin-bottom: 150px;
  }
}
</style>
